"use client";
import React from "react";
import { ClerkProvider as Clerk } from "@clerk/nextjs";

export default function ClerkProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <Clerk dynamic>{children}</Clerk>;
}
